export default function correctPosition(position, rect) {
  const tooltipWidth = 250; // Примерная ширина тултипа
  const tooltipHeight = 80; // Примерная высота тултипа
  const viewportWidth = window.innerWidth;
  const viewportHeight = window.innerHeight;

  if (position.left + tooltipWidth > viewportWidth) {
    position.left = viewportWidth - tooltipWidth + 90;
  }

  if (position.left < 150) {
    position.left = 140;
  }

  if (position.top + tooltipHeight > viewportHeight) {
    position.top = rect.top + window.scrollY - tooltipHeight;
  }

  return position;
}

